






























import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-property-decorator";
import ClickOutside from "vue-click-outside";

@Component({
  components: {
    ValidationProvider,
  },
  directives: {
    ClickOutside,
  },
})
export default class FormSelect extends Vue {
  @Prop() name?: string;

  @Prop() value?: SelectOption;

  @Prop() placeholder?: string;

  @Prop() rules?: string | object;

  @Prop() label?: string;

  @Prop({ default: "bottom" }) dir?: "top" | "bottom";

  @Prop({ default: () => [] }) options!: SelectOption[];

  @Prop({ default: true }) showError?: boolean;

  @Prop({ default: false }) disabled!: boolean;

  @Prop({ default: "text-14" }) labelClass!: string;

  @Prop({ default: "border  border-gray-100 dark:border-white bg-none" }) containerClass!: string;

  @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

  localValue: string | number = "";

  open = false;

  private get formValdiated(): boolean {
    return this.provider.$_veeObserver?.flags?.validated;
  }

  private get validateAs(): string {
    if (this.label) {
      return this.label;
    }

    if (this.placeholder) {
      return this.placeholder;
    }

    if (this.name) {
      return this.name;
    }

    return `select field`;
  }

  handleOpen() {
    if (this.disabled) {
      return;
    }

    this.open = !this.open;
  }

  private get selectedValue(): string | number | undefined {
    const match = this.options.find((o: SelectOption) => o.value == this.localValue);

    if (!match) {
      return "";
    }

    return match.hasOwnProperty("htmlLabel") ? match.htmlLabel : match.label;
  }

  @Emit("input")
  private selectOption(value: string | number) {
    this.localValue = value;
    this.open = false;
    return value;
  }

  @Watch("value", { immediate: true })
  private valueChanged(newValue?: string | number) {
    if (newValue || newValue === 0) {
      this.localValue = newValue;
    }
  }
}
